import { Component, ChangeDetectionStrategy, computed, inject, input } from "@angular/core";
import { RouterModule } from "@angular/router";
import { toSignal } from "@angular/core/rxjs-interop";
import { Store } from "@ngrx/store";
import { TranslateModule } from "@ngx-translate/core";
import { TooltipModule } from "primeng/tooltip";
import { RippleModule } from "primeng/ripple";

import { UserContext } from "src/app/store/user/user.state";
import { selectContact } from "src/app/store/pages/contact/contact.selectors";
import { NavRoutesService } from "src/app/navigation/nav-routes.service";
import { NavContextHeaderComponent } from "../../parts/nav-context-header/nav-context-header.component";

@Component({
    selector: "app-contact-view",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterModule, TranslateModule, TooltipModule, RippleModule, NavContextHeaderComponent],
    templateUrl: "./contact-view.component.html",
    styleUrl: "./contact-view.component.scss",
})
export class ContactViewComponent {

    // =========================================================================
    // DEPENDENCY INJECTION
    // =========================================================================
    private readonly store = inject(Store);
    private readonly navRoutes = inject(NavRoutesService);

    // =========================================================================
    // INPUTS
    // =========================================================================
    public readonly expanded = input.required<boolean>();
    public readonly user = input.required<UserContext | null>();

    // =========================================================================
    // STORE SIGNALS
    // =========================================================================
    private readonly contact = toSignal(this.store.select(selectContact), { initialValue: null });

    // =========================================================================
    // COMPUTED - Routes
    // =========================================================================
    public readonly overviewRoute = computed(() => {
        const contactId = this.contact()?.id;
        return contactId ? this.navRoutes.route("contact", contactId, "overview") : null;
    });

    // =========================================================================
    // COMPUTED - Header
    // =========================================================================
    public readonly contactsListRoute = computed(() => this.navRoutes.route("contact"));
    public readonly headerTitle = computed(() => {
        const contact = this.contact();
        if (!contact) return "";
        return contact.name || "";
    });
    public readonly headerLoading = computed(() => !this.contact()?.name && !this.contact()?.id);
}
